import { HttpContextToken } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

/** Set on an HttpRequest context to suppress the global spinner for that call. */
export const SKIP_SPINNER = new HttpContextToken<boolean>(() => false);

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  stack = 0;

  constructor(
    private spinner: NgxSpinnerService,
    private ngZone: NgZone,
  ) {}

  show(): void {
    this.ngZone.run(() => {
      this.stack++;
      if (this.stack === 1) {
        this.spinner.show();
      }
    });
  }

  hide(): void {
    this.ngZone.run(() => {
      if (this.stack > 0) {
        this.stack--;
        if (this.stack === 0) {
          this.spinner.hide();
        }
      }
    });
  }
}
